import { useParams } from "react-router-dom";

import { Layout } from "Layout";

import { ListPage } from "components/ListPage/ListPage";

import { i18n } from "services/i18nService";

import { useEditModal } from "hooks/useEditModal";
import { usePrivileges } from "hooks/usePrivileges";

import { Forbidden } from "Forbidden";
import { USER_PRIVILEGE, OBJECT_TYPES } from "appConstants";

const objectType = OBJECT_TYPES.CUSTOMER.fullString;

export function CustomerList() {
  const { id } = useParams();
  const { hasPrivilegesOrIsAdmin } = usePrivileges();
  const allowList = hasPrivilegesOrIsAdmin([
    USER_PRIVILEGE.viewCustomers,
    USER_PRIVILEGE.editCustomers,
  ]);
  useEditModal(objectType, id);

  return (
    <Layout pageTitle={i18n(`objectType.${objectType}.SentencePlural`)}>
      {allowList ? <ListPage objectType={objectType} /> : <Forbidden />}
    </Layout>
  );
}
